import { ref } from 'vue';
import { isWeixinBrowser, isWeiboBrowser } from './utils';
export default {
  name: "App",
  setup() {
    const coverShow = ref(false);
    if (isWeiboBrowser() || isWeixinBrowser()) {
      coverShow.value = true;
    }
    return {
      coverShow
    };
  }
};